export default "/images/vendor/flag-icons/flags/1x1/gr.svg?f4f1efd04d192aac3cbe69e75c994783";